<div class="container-fluid bg-white vh-100 p-0">
  <!-- Client Logo Component -->
  <ClientLogo v-if="this.$route.name != 'behalf_application'" />

  <!-- Breadcrumb Component -->
  <BreadCrumb label="Company Credit Check" />

  <!-- Form Container -->
  <div>
    <div class="d-flex justify-content-center align-items-center min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <!-- Error Message Display -->
        <div v-if="error" class="alert alert-danger text-center">
          {{ error }}
        </div>

        <!-- Enterprise TransUnion Credit Check Form -->
        <form @submit.prevent="enterprise_transunion_credit_check">
          <!-- Registration Number Field -->
          <div class="form-group mt-3">
            <label for="registrationNumber" class="fw-bold text-xs text-start d-block">
              Registration Number <span class="text-danger">*</span>
            </label>
            <input
              v-model="registration_number"
              type="text"
              class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
              id="registrationNumber"
              placeholder="e.g., 201903520321"
              @input="validate_registration_number"
              required
              :disabled="isFieldDisabled.registration_number"
            />
            <small v-if="error_messages.registration_number" class="form-text text-danger">
              {{ error_messages.registration_number }}
            </small>
          </div>

          <!-- Submit Button -->
          <div class="text-center mb-3 mt-4">
            <button
              type="submit"
              class="btn bg-green btn-sm px-4 rounded-small shadow-sm fw-bold secondary-text-dark text-xs"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>